/* ADD POLL */
export const REMOVE_POLL_ANSWER = "REMOVE_POLL_ANSWER"
export const REMOVE_POLL_ANSWER_SUCCESS = "REMOVE_POLL_ANSWER_SUCCESS"
export const REMOVE_POLL_ANSWER_CLEAN = "REMOVE_POLL_ANSWER_CLEAN"
export const REMOVE_POLL_ANSWER_ERROR = "REMOVE_POLL_ANSWER_ERROR"
